export const priceMaxLength = 5
